/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
export type SearchCalendarSummaryFunctionCalendarSummaryFragment = { guid: string, description: string | null, publicTitle: string, privateTitle: string | null, assignedStaffs: Array<{ displayName: string }> };

export const SearchCalendarSummaryFunctionCalendarSummaryFragmentDoc = gql`
    fragment SearchCalendarSummaryFunctionCalendarSummary on CalendarSummary {
  guid
  description
  assignedStaffs {
    displayName
  }
  publicTitle
  privateTitle
}
    `;